export default __webpack_public_path__ + "9da928cb8ac6ecf059179cbf18ec54bb.bmp";